import { createAction, props } from '@ngrx/store';
import { Theme } from '../../models/theme.models';

export const ChangeTheme = createAction('[Theme] Change Theme', props<{ themeKey: Theme }>());
export const ChangeDarkMode = createAction('[Theme] Change Dark Mode', props<{ darkMode: boolean }>());
export const ToggleDarkMode = createAction('[Theme] Toggle Dark Mode');
